import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';
import { LocalRepository } from '@shared/helper/local-repository';

@Component({
    selector: 'app-otp-input',
    imports: [
        ReactiveFormsModule,
        NgClass
    ],
    templateUrl: './otp-input.component.html',
    styleUrl: './otp-input.component.scss'
})
export class OtpInputComponent implements OnInit, OnDestroy {

  @Input() hasError = false;
  @Output() codeCompleted = new EventEmitter<string>();
  fb: FormBuilder = inject(FormBuilder);
  repo: LocalRepository = inject(LocalRepository);
  form!: FormGroup;
  subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.initForm();
    this.onFormValueChange();
    this.form.valueChanges.subscribe(() => {
      this.emitValue();
    });
  }


  // TODO a form array is needed
  initForm() {
    this.form = this.fb.group({
      digit1: new FormControl(null, [Validators.required, Validators.maxLength(1)]),
      digit2: new FormControl(null, [Validators.required, Validators.maxLength(1)]),
      digit3: new FormControl(null, [Validators.required, Validators.maxLength(1)]),
      digit4: new FormControl(null, [Validators.required, Validators.maxLength(1)])
    });
  }

  onFormValueChange() {
    this.subscriptions.push(
      this.form.controls['digit1'].valueChanges.subscribe(v => {
        if (v != null)
          this.getInputByIndex(2)?.focus();
      })
    );
    this.subscriptions.push(
      this.form.controls['digit2'].valueChanges.subscribe(v => {
        if (v != null)
          this.getInputByIndex(3)?.focus();
      })
    );
    this.subscriptions.push(
      this.form.controls['digit3'].valueChanges.subscribe(v => {
        if (v != null)
          this.getInputByIndex(4)?.focus();
      })
    );
    this.subscriptions.push(
      this.form.controls['digit4'].valueChanges.subscribe(v => {
        if (v == null)
          this.getInputByIndex(3)?.focus();
      })
    );
  }

  // ? Find the id of previous index
  getInputByIndex(index: number): HTMLInputElement | null {
    const inputId = 'digit' + String(index);
    return this.repo.getDocument?.getElementById(inputId) as HTMLInputElement;
  }

  // ? Enter and check Otp code with api
  emitValue() {
    const code = String(this.form.value.digit1) + String(this.form.value.digit2) + String(this.form.value.digit3) + String(this.form.value.digit4);
    this.codeCompleted.emit(code);
  }

  handleBackSpace(event: any, index: number) {
    if (event.key === 'Backspace' && !event.target.value && index > 0) {
      index === 1 ? this.getInputByIndex(index)?.focus() : this.getInputByIndex(index - 1)?.focus();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

}
